import React, { useState, useEffect } from "react";
import { Grid, Button, Box, ButtonGroup, Typography } from "@mui/material";
import { StyledDialog, StyledPaper } from "../StyledMui";
import useStore from "../Store";
import ManageTemplateModal from "../Modals/ManageTemplateModal";
import ManageImageModal from "../Modals/ManageImageModal";

function Header() {
  const { openModal } = useStore((state) => state.header);
  return (
    <>
      <StyledPaper>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Box gap="0.5rem" display="flex" alignItems="center">
            <i class="xi-kakaotalk xi-2x"></i>
            <Typography variant="h6">카카오톡 메세지 발송설정</Typography>
          </Box>
          <Grid item xs={12}>
            <Box display="flex" justifyContent="flex-end" alignItems="center">
              <ButtonGroup variant="contained">
                <Button onClick={() => openModal("imageModal")}>이미지 관리</Button>
                <Button onClick={() => openModal("templateModal")}>템플릿 관리</Button>
              </ButtonGroup>
            </Box>
          </Grid>
        </Box>
      </StyledPaper>
      <ManageTemplateModal />
      <ManageImageModal />
    </>
  );
}

export default Header;
